export class ELocalData {
  _name: string;
  _value: number;

  constructor(name: string, value: number) {
    this._name = name;
    this._value = value;
  }
}
